// @flow

import { createSelector, type OutputSelector } from 'reselect';

import {
  selectCartIsCommitted,
  selectCartUUID as selectCartId,
  selectCartConfigurations as selectConfigurations,
  type CartConfiguration as Configuration,
  type Process,
} from '@gandi/cart';

import { getSetupOverviewUrl } from 'src/Cart/Setup/modules/helpers';

import { useAppSelector } from 'src/hooks';
import type { FullState } from 'src/types';

export type DomainConfiguration = {
  committed: boolean,
  templateChangeURL: string,
  configuration: void | Configuration,
};

const selectProcess = (_: FullState, process: Process) => process;
const selectConfiguration: OutputSelector<
  FullState,
  Process,
  void | Configuration,
> = createSelector(
  [selectConfigurations, selectProcess],
  (cartConfigurations, process) =>
    cartConfigurations.find(
      ({ product_type: productType, process: _process }) =>
        productType === 'domain' && _process === process,
    ),
);

export function useDomainConfiguration(process: Process): DomainConfiguration {
  const committed = useAppSelector(selectCartIsCommitted);
  const configuration = useAppSelector(state =>
    selectConfiguration(state, process),
  );
  const cartId = useAppSelector(selectCartId);
  const templateChangeURL = getSetupOverviewUrl(cartId, process);

  return { committed, configuration, templateChangeURL };
}
